/**
 * Paylux panel yardımcıları.
 *
 * Ayarlar `settings` kaydında **değildir** — `provider_configs` satırında tek
 * bir JSON gövdesidir (bkz. backend/services/paylux.py). Sırlar (`api_key`,
 * `secret_key`) sunucudan geri dönmez; boş bırakılan sır gönderilmez, yani
 * kayıtlı değer korunur. `firma_id` bilinçli olarak sır değildir: hash'in
 * parçasıdır ama tek başına kimlik kanıtlamaz ve hash tutmadığında ilk
 * bakılacak yer odur.
 */

export const PAYLUX_DEFAULTS = {
  enabled: false,
  api_url: 'https://paylux.org/xApi/customer',
  api_key: '',
  firma_id: '',
  secret_key: '',
  callback_url: '',
  callback_registered: false,
  return_url: '',
  deposit_enabled: true,
  withdraw_enabled: true,
  deposit_min_amount: 100,
  deposit_max_amount: 50000,
  withdraw_min_amount: 100,
  withdraw_max_amount: 50000,
};

export const CALLBACK_PATH = '/api/paylux/callback';

const SECRET_KEYS = ['api_key', 'secret_key'];

// Adresi biz üretiriz, yönetici yazmaz: ikisi de kaydedilirken güncel site
// kökünden türetilir (bkz. CLAUDE.md → *Alan adı değişince adresler geride
// kalır*).
const DERIVED_KEYS = ['callback_url', 'return_url'];

const sameValue = (a, b) => {
  if (typeof a === 'boolean' || typeof b === 'boolean') {
    return Boolean(a) === Boolean(b);
  }
  if (typeof a === 'number' || typeof b === 'number') {
    const left = Number(a ?? 0);
    const right = Number(b ?? 0);
    if (Number.isFinite(left) && Number.isFinite(right)) return left === right;
  }
  return String(a ?? '') === String(b ?? '');
};

/**
 * Sunucuya gönderilecek gövde: yalnızca değişen alanlar. Bildirim ve dönüş
 * adresleri salt okunurdur; kayıttaki değer geride kalmışsa kaydedilirken
 * düzeltilir.
 */
export const changedFields = (current, initial, options = {}) => {
  const { paymentBase = '', siteBase = '' } = options;
  const values = current || {};
  const saved = initial || {};
  const payload = {};
  Object.keys(PAYLUX_DEFAULTS).forEach((key) => {
    if (DERIVED_KEYS.includes(key)) return;
    const next = values[key];
    if (next === undefined) return;
    if (SECRET_KEYS.includes(key)) {
      if (String(next || '').trim()) payload[key] = String(next).trim();
      return;
    }
    if (!sameValue(next, saved[key])) payload[key] = next;
  });
  if (paymentBase) {
    const url = `${paymentBase}${CALLBACK_PATH}`;
    if (!sameValue(saved.callback_url, url)) payload.callback_url = url;
  }
  // Dönüş adresi oyuncunun tarayıcısına verilir, bu yüzden adres defterine
  // değil **yaşayan siteye** bağlanır (site_address → SITE_ROLE kuralı):
  // sabit bir adrese düşen oyuncu yayındaki siteyi göremezdi.
  if (siteBase) {
    const url = `${siteBase}/hesap/para-yatir`;
    if (!sameValue(saved.return_url, url)) payload.return_url = url;
  }
  return payload;
};
